// src/components/History/style.ts
import styled from '@emotion/styled'
import theme from '@utils/theme'

export const HistoryContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 0px 0px;
  }
`

export const BookSection = styled.div`
  display: flex;
  margin-top: 20px;

  flex-direction: column;
  height: 100%;
  justify-content: center;
  min-height: 300px;
`

export const BookInformation = styled.div`
  display: flex;
  gap: 12px;
`

export const BookList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`

export const LendingBook = styled.div`
  width: 100%;
  margin-right: 20px;
`

export const BorrowingBook = styled.div`
  flex: 1;
`

export const BookEntry = styled.div`
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
  cursor: pointer;
  @media (max-width: 768px) {
    max-width: 100%;
  }
`

export const BookCover = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 4px;
`
export const BookWrapper = styled.div`
  width: 70px;
  height: auto;
  border-radius: 4px;
  aspect-ratio: 2/3;
`

export const BookInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const BookTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  color: #333;
`

export const BookDetails = styled.p`
  /* margin: 5px 0; */
  font-size: 14px;
  color: #666;
`

export const StatusBadge = styled.span<{ status: string }>`
  border-radius: 4px;
  font-size: 12px;

  font-size: 12px;
  padding: 5px 8px;
  display: block;
  text-align: center;
  width: max-content;
  @media (max-width: 768px) {
    font-size: 10px;
  }

  @media (max-width: 480px) {
    font-size: 9px;
  }
  background-color: ${(props) => {
    switch (props.status) {
      case 'overdue':
        return '#ffcccb'
      case 'pending':
        return '#ffe4b5'
      case 'confirmed':
        return '#90ee90'
      default:
        return '#f0f0f0'
    }
  }};

  color: ${(props) => {
    switch (props.status) {
      case 'overdue':
        return '#d9534f'
      case 'pending':
        return '#f0ad4e'
      case 'confirmed':
        return '#5cb85c'
      default:
        return '#333'
    }
  }};
`

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  gap: 20px;
  margin-bottom: 20px;
`

export const ToggleButton = styled.div<{ active: boolean }>`
  cursor: pointer;
  width: 100%;
  padding: 10px 15px;
  /* font-weight: ${(props) => (props.active ? 'bold' : 'normal')}; */
  border-bottom: ${(props) =>
    props.active ? `2px solid ${theme.colors.primary}` : 'none'};
  color: ${(props) => (props.active ? theme.colors.primary : '#666')};
  transition: all 0.3s ease;
  font-size: 14px;
  &:hover {
    color: ${theme.colors.primary};
  }
`

export const LendToInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
  border: 1px solid #e0e0e0;
  padding: 10px;
  border-radius: 8px;
`

export const DriverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
  border: 1px solid #e0e0e0;
  padding: 10px;
  border-radius: 8px;
  height: 104px;
`

export const HistoryLendToContainer = styled.div`
  border-radius: 8px;
  padding: 15px;
  margin-top: 10px;
  border: 1px solid #e0e0e0;
`

export const HistoryLendHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`

export const LenderName = styled.p`
  font-weight: 500;
  font-size: 12px;

  span {
    color: #007bff;
  }
`

export const LendDate = styled.p`
  background-color: #e6f2ff;
  color: #0056b3;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 0.7rem;
  span {
    font-weight: 500;
  }
`

export const LendDateDetails = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;
`

export const LendDateColumn = styled.div`
  > p:first-of-type {
    margin-bottom: 8px;
    color: #666;
    font-size: 0.8rem;
  }
`

export const IssueDateBadge = styled.p`
  color: white;
  background-color: #28a745;
  border-radius: 4px;
  padding: 6px 10px;
  text-align: center;
  font-size: 10px;
`

export const ReturnDateBadge = styled.p`
  color: white;
  background-color: #dc3545;
  border-radius: 4px;
  padding: 6px 10px;
  text-align: center;
  font-size: 10px;
`

export const StyleDriverStatus = styled.div<any>`
  background: ${(props: any) => props.theme.colors[props?.bg || 'primary50']};
  color: ${(props: any) => props.theme.colors[props?.tc || 'primary']};
  font-size: 12px;
  padding: 5px 8px;
  border-radius: 4px;
  display: block;
  text-align: center;
  width: max-content;

  @media (max-width: 768px) {
    font-size: 10px;
  }

  @media (max-width: 480px) {
    font-size: 9px;
  }
`
